import React, { useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";

import DrawDeck, { CANVAS_SIZE } from "./DrawDeck";
import { Button, Dialog } from "@mui/material";
import { DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

function DeckStructure({ deckState, updateDeckState }) {
    const canvasRef = useRef(null);
    const textFields = useRef({});

    const { deckShape, deckRotation, deckHeight } = deckState.deckStructure;

    const [showPopup, setShowPopup] = useState(false);
    const [accepted, setAccepted] = useState(false);

    React.useEffect(() => {
        if (deckHeight >= 3000 && !accepted) {
            setShowPopup(true);
            // set default attachment to timber
            updateDeckState({
                ...deckState,
                deckStructure: {
                    ...deckState.deckStructure, // Spread the existing deckStructure
                    deckAttachment: "Timber", // Update the deckShape property
                },
            });
        } else if (deckHeight <= 3000) {
            setAccepted(false);
        }
    }, [deckHeight]);

    let rect1Length = deckState.deckStructure.lengthA;
    let rect1Height = deckState.deckStructure.widthA;
    let rect2Length = deckState.deckStructure.lengthB;
    let rect2Height = deckState.deckStructure.widthB;

    const rotateCanvas = (rotation) => {
        let newRotation = rotation + deckRotation;
        if (newRotation < 0) {
            newRotation = newRotation + 360;
        }
        if (newRotation >= 360) {
            newRotation = newRotation - 360;
        }
        updateDeckState({
            ...deckState,
            deckStructure: {
                ...deckState.deckStructure,
                deckRotation: newRotation,
            },
        });
    };

    return (
        <div
            style={{
                padding: 15,
                display: "flex",
                gap: "20px",
            }}
        >
            <DrawDeck
                textEditable={true}
                canvasRef={canvasRef}
                textFields={textFields}
                deckShape={deckShape}
                deckRotation={deckRotation}
                deckState={deckState}
                updateDeckState={updateDeckState}
                showDeckLay={true}
            />
            <div>
                <h3 style={{ padding: "20px 0px", margin: 0 }}>Deck Dimensions</h3>
                <p>
                    Modify your deck dimensions to suit your needs. Note this can be changed later.
                    <b>
                        <u>• Dimensions are in MM.</u>
                    </b>
                </p>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ margin: 0 }}>
                        Joist Spacing Direction&nbsp;- <span style={{ color: "blue", margin: 0 }}>BLUE BOLD</span>
                    </p>
                    <p style={{ margin: 0, marginLeft: "10px" }}>
                        Flooring Material Direction&nbsp;-{" "}
                        <span style={{ color: "orange", margin: 0 }}>ORANGE DOTTED</span>
                    </p>
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "start",
                        padding: "10px",
                    }}
                >
                    <div style={{ marginTop: 20, marginRight: 20 }}>
                        <Button
                            variant="outlined"
                            onClick={() => rotateCanvas(-90)} // Rotate left by 90 degrees
                        >
                            Rotate Left
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => rotateCanvas(90)} // Rotate right by 90 degrees
                        >
                            Rotate Right
                        </Button>
                        <div style={{ padding: 5, margin: 5 }}>
                            <TextField
                                sx={{ margin: 1 }}
                                label="Deck Height"
                                type="number"
                                value={deckState.deckStructure.deckHeight}
                                onBlur={(e) =>
                                    updateDeckState({
                                        ...deckState,
                                        deckStructure: {
                                            ...deckState.deckStructure, // Spread the existing deckStructure
                                            deckHeight: Math.max(parseInt(e.target.value), 500), // Update the deckShape property
                                        },
                                    })
                                }
                                onChange={(e) =>
                                    updateDeckState({
                                        ...deckState,
                                        deckStructure: {
                                            ...deckState.deckStructure, // Spread the existing deckStructure
                                            deckHeight: parseInt(e.target.value),
                                        },
                                    })
                                }
                            />
                            {accepted ? (
                                <div>
                                    Over 3m (design will require supplementary engineering as per NCC 2022 Vol 2 H1D11
                                    (b))
                                </div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Dialog disableEnforceFocus open={showPopup}>
                <DialogTitle>Warning</DialogTitle>
                <DialogContent>
                    As this deck exceeds 3m in height, the design will require supplementary engineering as per NCC 2022
                    Vol 2 H1D11 (b)
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setShowPopup(false);
                            setAccepted(true);
                            updateDeckState({
                                ...deckState,
                                deckAttachments: { rect1: {}, rect2: {} },
                            });
                        }}
                    >
                        Accept
                    </Button>
                    <Button
                        onClick={() => {
                            setShowPopup(false);
                            updateDeckState({
                                ...deckState,
                                deckStructure: {
                                    ...deckState.deckStructure,
                                    deckHeight: 500,
                                },
                            });
                        }}
                    >
                        Reject (set back to 500mm)
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default DeckStructure;
